import { Expandable } from '@sparkpost/matchbox';

/**
 * Matchbox Expandable component
 * @see https://design.sparkpost.com/components/expandable/
 */
export default Expandable;
